// import css from "./priceOpt.module.css";
// import { useState } from "react";
// import addToCart from "../../function/addToCard";
// import { PhotoProvider, PhotoView } from "react-photo-view";
// import "react-photo-view/dist/react-photo-view.css";
// import { Link } from "react-router-dom";
// import { getProductHref } from "../../function/productLink";
// import { saveCartToStorage } from "../../function/cartStorage";
// export default function ProductInOpt({
//   el,
//   setTotalPrice,
//   setHaveProduct,
//   haveProduct,
//   setCartCounterC,
// }) {
//   const [countProd, setCountProd] = useState(0);

//   const getProductCurrentPrice = (product) => {
//     if (product?.priceSale && product.priceSale !== "") {
//       return Number(product.price) || 0;
//     }

//     if (product?.salePrice) {
//       return Number(product.salePrice) || 0;
//     }

//     if (product?.actionPrice) {
//       return Number(product.actionPrice) || 0;
//     }

//     return Number(product?.price) || 0;
//   };

//   const renderPrice = () => {
//     if (el?.priceSale && el.priceSale !== "") {
//       return (
//         <div className={css.optSaleRomb}>
//           <div className={css.optSaleRombInner}>
//             <p className={css.optOldPrice}>{el.priceSale}</p>
//             <p className={css.optNewPrice}>{el.price}</p>
//             <p className={css.optCurrency}>грн</p>
//           </div>
//         </div>
//       );
//     }

//     if (el?.salePrice) {
//       return (
//         <div className={css.optSaleRomb}>
//           <div className={css.optSaleRombInner}>
//             <p className={css.optOldPrice}>{el.price}</p>
//             <p className={css.optNewPrice}>{el.salePrice}</p>
//             <p className={css.optCurrency}>грн</p>
//           </div>
//         </div>
//       );
//     }

//     if (el?.actionPrice) {
//       return (
//         <div className={css.optSaleRomb}>
//           <div className={css.optSaleRombInner}>
//             <p className={css.optOldPrice}>{el.price}</p>
//             <p className={css.optNewPrice}>{el.actionPrice}</p>
//             <p className={css.optCurrency}>грн</p>
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className={css.rombWrapSecond}>
//         <div className={css.rombWrapPod}>
//           <p className={css.pricePodRomb}>{el.price}</p>
//           <p className={css.pricePodRombText}>грн</p>
//         </div>
//       </div>
//     );
//   };

//   const updateCartQuantity = (newQuantity) => {
//     let cartItems = [];

//     const storedCart = localStorage.getItem("cart");
//     if (storedCart) {
//       cartItems = JSON.parse(storedCart);
//     }

//     const existingProductIndex = cartItems.findIndex(
//       (item) => item.uid === el.uid,
//     );

//     if (existingProductIndex !== -1) {
//       if (newQuantity <= 0) {
//         cartItems.splice(existingProductIndex, 1);
//       } else {
//         cartItems[existingProductIndex].quantity = newQuantity;
//       }

//       // localStorage.setItem("cart", JSON.stringify(cartItems));
//       saveCartToStorage(cartItems);
//     }
//   };

//   const changeStateDown = () => {
//     if (countProd <= 0) return;

//     const newCount = countProd - 1;

//     updateCartQuantity(newCount);
//     setCountProd(newCount);
//     setHaveProduct(!haveProduct);
//     setCartCounterC((prev) => prev + 1);
//   };

//   const changeStateUp = () => {
//     if (countProd === 0) {
//       addToCart(el.uid);
//       setCountProd(1);
//     } else {
//       const newCount = countProd + 1;
//       updateCartQuantity(newCount);
//       setCountProd(newCount);
//     }

//     setHaveProduct(!haveProduct);
//     setCartCounterC((prev) => prev + 1);
//   };

//   return (
//     <div className={css.blockSoonSecond}>
//       <PhotoProvider>
//         {Array.isArray(el.imageList) && el.imageList[0] && (
//           <PhotoView src={el.imageList[0]}>
//             <img
//               src={el.imageList[0]}
//               alt={el.bookName}
//               className={css.soonPicProdSt}
//             />
//           </PhotoView>
//         )}

//         {Array.isArray(el.imageList) &&
//           el.imageList.slice(1).map((item, index) => (
//             <PhotoView key={index} src={item}>
//               <span style={{ display: "none" }} />
//             </PhotoView>
//           ))}
//       </PhotoProvider>

//       <div className={css.soonPicProdStDesc}>
//         <p className={css.soonAuthor}>{el.textAutor}</p>

//         <Link to={getProductHref(el)} className={css.soonAuthorName}>
//           {el.bookName}
//         </Link>

//         {renderPrice()}

//         <div className={css.counterWrapSecond}>
//           <div onClick={changeStateDown} className={css.boxCount}>
//             -
//           </div>

//           <p className={css.theCount}>{countProd}</p>

//           <div onClick={changeStateUp} className={css.boxCount}>
//             +
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import css from "./priceOpt.module.css";
import { useEffect, useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Link } from "react-router-dom";
import { getProductHref } from "../../function/productLink";
import { saveCartToStorage } from "../../function/cartStorage";
export default function ProductInOpt({
  el,
  setTotalPrice,
  setHaveProduct,
  haveProduct,
  setCartCounterC,
}) {
  const [countProd, setCountProd] = useState(0);
  const getCartItems = () => {
    try {
      const storedCart = localStorage.getItem("cart");
      return storedCart ? JSON.parse(storedCart) : [];
    } catch (error) {
      console.error("Помилка читання кошика:", error);
      return [];
    }
  };

  const getCurrentProductQuantity = () => {
    const cartItems = getCartItems();

    const cartProduct = cartItems.find((item) => item.uid === el.uid);

    return Number(cartProduct?.quantity) || 0;
  };

  useEffect(() => {
    const syncQuantityFromCart = () => {
      setCountProd(getCurrentProductQuantity());
    };

    syncQuantityFromCart();

    window.addEventListener("cartUpdated", syncQuantityFromCart);
    window.addEventListener("storage", syncQuantityFromCart);
    window.addEventListener("focus", syncQuantityFromCart);

    return () => {
      window.removeEventListener("cartUpdated", syncQuantityFromCart);
      window.removeEventListener("storage", syncQuantityFromCart);
      window.removeEventListener("focus", syncQuantityFromCart);
    };
  }, [el.uid]);
  const getProductCurrentPrice = (product) => {
    if (product?.priceSale && product.priceSale !== "") {
      return Number(product.price) || 0;
    }

    if (product?.salePrice) {
      return Number(product.salePrice) || 0;
    }

    if (product?.actionPrice) {
      return Number(product.actionPrice) || 0;
    }

    return Number(product?.price) || 0;
  };

  const renderPrice = () => {
    if (el?.priceSale && el.priceSale !== "") {
      return (
        <div className={css.optSaleRomb}>
          <div className={css.optSaleRombInner}>
            <p className={css.optOldPrice}>{el.priceSale}</p>
            <p className={css.optNewPrice}>{el.price}</p>
            <p className={css.optCurrency}>грн</p>
          </div>
        </div>
      );
    }

    if (el?.salePrice) {
      return (
        <div className={css.optSaleRomb}>
          <div className={css.optSaleRombInner}>
            <p className={css.optOldPrice}>{el.price}</p>
            <p className={css.optNewPrice}>{el.salePrice}</p>
            <p className={css.optCurrency}>грн</p>
          </div>
        </div>
      );
    }

    if (el?.actionPrice) {
      return (
        <div className={css.optSaleRomb}>
          <div className={css.optSaleRombInner}>
            <p className={css.optOldPrice}>{el.price}</p>
            <p className={css.optNewPrice}>{el.actionPrice}</p>
            <p className={css.optCurrency}>грн</p>
          </div>
        </div>
      );
    }

    return (
      <div className={css.rombWrapSecond}>
        <div className={css.rombWrapPod}>
          <p className={css.pricePodRomb}>{el.price}</p>
          <p className={css.pricePodRombText}>грн</p>
        </div>
      </div>
    );
  };

  const updateCartQuantity = (newQuantity) => {
    const quantity = Math.max(0, Number(newQuantity) || 0);

    const cartItems = getCartItems();

    const existingProductIndex = cartItems.findIndex(
      (item) => item.uid === el.uid,
    );

    if (existingProductIndex !== -1) {
      if (quantity <= 0) {
        cartItems.splice(existingProductIndex, 1);
      } else {
        cartItems[existingProductIndex].quantity = quantity;
      }
    } else if (quantity > 0) {
      cartItems.push({
        uid: el.uid,
        quantity,
      });
    }

    saveCartToStorage(cartItems);
  };

  // const changeStateDown = () => {
  //   const currentQuantity = getCurrentProductQuantity();

  //   if (currentQuantity <= 0) return;

  //   const newCount = currentQuantity - 1;

  //   updateCartQuantity(newCount);
  //   setCountProd(newCount);

  //   setHaveProduct((prev) => !prev);
  //   setCartCounterC((prev) => prev + 1);
  // };

  // const changeStateUp = () => {
  //   const currentQuantity = getCurrentProductQuantity();
  //   const newCount = currentQuantity + 1;

  //   updateCartQuantity(newCount);
  //   setCountProd(newCount);

  //   setHaveProduct((prev) => !prev);
  //   setCartCounterC((prev) => prev + 1);
  // };
  const notifyCartChanged = () => {
    setHaveProduct((prev) => !prev);
    setCartCounterC((prev) => prev + 1);
  };

  const commitQuantity = (value) => {
    const quantity = Math.max(0, Number(value) || 0);

    updateCartQuantity(quantity);
    setCountProd(quantity);
    notifyCartChanged();
  };

  const changeStateDown = () => {
    const currentQuantity = getCurrentProductQuantity();

    if (currentQuantity <= 0) return;

    commitQuantity(currentQuantity - 1);
  };

  const changeStateUp = () => {
    const currentQuantity = getCurrentProductQuantity();

    commitQuantity(currentQuantity + 1);
  };

  const handleQuantityInputChange = (event) => {
    const onlyNumbers = event.target.value.replace(/\D/g, "");

    if (onlyNumbers === "") {
      setCountProd("");
      return;
    }

    commitQuantity(Number(onlyNumbers));
  };

  const handleQuantityInputBlur = () => {
    if (countProd === "" || Number(countProd) < 0) {
      commitQuantity(0);
    }
  };

  const handleQuantityInputKeyDown = (event) => {
    if (event.key === "Enter") {
      event.currentTarget.blur();
    }
  };
  return (
    <div className={css.blockSoonSecond}>
      <PhotoProvider>
        {Array.isArray(el.imageList) && el.imageList[0] && (
          <PhotoView src={el.imageList[0]}>
            <img
              src={el.imageList[0]}
              alt={el.bookName}
              className={css.soonPicProdSt}
            />
          </PhotoView>
        )}

        {Array.isArray(el.imageList) &&
          el.imageList.slice(1).map((item, index) => (
            <PhotoView key={index} src={item}>
              <span style={{ display: "none" }} />
            </PhotoView>
          ))}
      </PhotoProvider>

      <div className={css.soonPicProdStDesc}>
        <p className={css.soonAuthor}>{el.textAutor}</p>

        <Link to={getProductHref(el)} className={css.soonAuthorName}>
          {el.bookName}
        </Link>

        {renderPrice()}

        <div className={css.counterWrapSecond}>
          <div onClick={changeStateDown} className={css.boxCount}>
            -
          </div>

          {/* <p className={css.theCount}>{countProd}</p> */}
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={countProd}
            onChange={handleQuantityInputChange}
            onBlur={handleQuantityInputBlur}
            onKeyDown={handleQuantityInputKeyDown}
            className={css.theCountInput}
            aria-label="Кількість товару"
          />
          <div onClick={changeStateUp} className={css.boxCount}>
            +
          </div>
        </div>
      </div>
    </div>
  );
}
